module.exports = __webpack_public_path__ + "img/image5.8ae4fb0c.png";